<template>
  <div class="v-itemWrap" :data-ring-id="ringQuickView['id']">
    <div class="v-labels">
      <div class="v-labels__item" v-if="ringQuickView['arluis_limited']">{{ $t("RingQuickView.arluis_limited") }}</div>
      <div class="v-labels__item" v-if="ringQuickView['ec_flag']">{{ $t("RingQuickView.ec_flag") }}</div>
      <div class="v-labels__item" v-if="ringQuickView['ec_try_flag']">{{ $t("RingQuickView.ec_try_flag") }}</div>
    </div>
    <div class="v-main">
      <img :src="ringQuickView[photoMode]" :alt="ringQuickView['name']" />
    </div>
    <ul class="v-list">
      <template v-for="l in filteredPhotoList">
        <li
          v-if="ringQuickView[l]"
          :class="[ 'v-list__item', l, photoMode === l ? 'v-list__item is-active' : 'v-list__item' ]"
          :key="l"
          @click="photoMode = l"
        >
          <img :src="ringQuickView[l]" :alt="l" />
        </li>
      </template>
    </ul>
    <div class="v-link">
      <a :href="ringQuickView['show_url']">{{ $t("RingQuickView.show") }}</a>
    </div>
    <div class="v-link" v-if="ringQuickView['blog_url']">
      <a :href="ringQuickView['blog_url']">{{ $t("RingQuickView.blog") }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RingQuickView',

  props: {
    ringQuickView: {
      type: Object,
      default: () => ({}),
      required: true,
    },
  },

  data () {
    return {
      photoMode: null, // 最初はnullにしておく
    }
  },

  computed: {
    filteredPhotoList() {
      const mainCategoryIds = [6, 7, 8, 9];
      let photoTypes = ['single_color_bg_photo', 'main_photo', 'sub_photo', 'hand_photo', 'hand_photo_2'];

      if (mainCategoryIds.includes(this.ringQuickView.ring_category_id)) {
        photoTypes = photoTypes.filter(photo => photo !== 'single_color_bg_photo');
      }

      return photoTypes;
    }
  },

  mounted() {
    // コンポーネントがマウントされた時にphotoModeをセット
    this.photoMode = this.filteredPhotoList[0];
  }
}
</script>

<style lang="scss" scoped>

.v-itemWrap {
  padding-bottom: 20px;
}

.v-main {
  max-width: 400px;
  margin: 0 auto;
}

.v-list {
  display: flex;
  justify-content: center;
  margin: 15px 0 20px;
}



.v-list__item {
  --item-size: 40px;
  cursor: pointer;
  width: var(--item-size);
  height: var(--item-size);
  border: 1px solid #d6d6d6;
  border-radius: 4px;
  margin: 0 5px;
  overflow: hidden;
  transition: .3s border-color;

  &.is-active {
    border-color: #808080;
  }

  @media screen and (min-width: 900px) {
    --item-size: 80px;
    margin: 0 10px;
  }
}

.v-link {
  text-align: center;
  font-size: 10px;
  margin: 0;

  > a {
    display: block;
    padding: 10px;
  }

  @media screen and (min-width: 900px) {
    font-size: 14px;
  }
}

.v-itemWrap[data-ring-id="110"],
.v-itemWrap[data-ring-id="169"] {
  .v-list__item.hand_photo,
  .v-list__item.hand_photo_2 {
    display: none;
  }
}

.v-itemWrap[data-ring-id="247"] {
  .v-list__item.hand_photo_2 {
    display: none;
  }
}

.v-itemWrap[data-ring-id="235"] {
  .v-list__item.sub_photo {
    display: none;
  }
}

.v-itemWrap[data-ring-id="236"] {
  .v-list__item.main_photo,
  .v-list__item.sub_photo {
    display: none;
  }
}

.v-labels {
  line-height: 1.2;
  text-align: center;
}

.v-labels__item {
  border: 1px solid var(--border-color);
  display: inline-block;
  padding: 0.2em 1em;
  font-size: 10px;
  margin: .5em
}

</style>
